import React from "react";
export default function MainHeading(props) {
  return (
    <div
      className={`flex justify-center flex-col items-center ${props.layout}`}
    >
      <div className="text-center relative w-full xs:mb-1 sm:mb-1 lg:mb-2">
        <h1 className="uppercase text-secondary xs:text-sm sm:text-lg lg:text-3xl xl:text-4xl font-unboundedBold">
          {props.title}
        </h1>
      </div>
      <p className="text-secondary font-onestLight text-center xs:text-xs sm:text-xs lg:text-sm">
        {props.dis}
      </p>
    </div>
  );
}
